module.exports = __webpack_public_path__ + "img/logo-mobile.29911b4a.svg";